import { useMemo, useRef, useState } from "react";
import { POSITIONS, type Position } from "@besenliga/shared";
import { browserStore, loadRoster } from "../creator/roster";
import { ControlsHelp, Feed, Minimap, PilotPanel, Scoreboard, useFlightView } from "./Hud";
import { clubsFor, pilotFrom } from "./pilot";

const ROLES: Position[] = ["artilheiro", "batedor", "cacador", "goleiro"];

/** Treino livre (itens 4.1 a 4.4): sem regras, os outros parados. `#voo?posicao=batedor` escolhe a posição. */
export function FlightScreen() {
  const holderRef = useRef<HTMLDivElement>(null);
  const saved = useMemo(() => loadRoster(browserStore())[0], []);
  const [role, setRole] = useState<Position>(() => {
    const asked = new URLSearchParams(location.hash.split("?")[1] ?? "").get("posicao");
    return asked && asked in POSITIONS ? (asked as Position) : (saved?.position ?? "artilheiro");
  });
  const pilot = useMemo(() => pilotFrom(saved, role), [saved, role]);
  const clubs = useMemo(() => clubsFor(pilot.kitId), [pilot.kitId]);
  const kits = useMemo(() => ({ casa: clubs.casa.kit, fora: clubs.fora.kit }), [clubs]);
  const { state, hud, view } = useFlightView(holderRef, pilot, "treino", clubs);

  return (
    <div className="stadium-screen flight-screen" data-state={state}>
      <div ref={holderRef} className="stadium-holder" />
      <header className="stadium-bar">
        <a href="#" className="ghost">
          Menu
        </a>
        <h1>Treino livre</h1>
      </header>
      {hud && <Scoreboard hud={hud} clubs={clubs} />}
      <div className="flight-roles segmented" role="group" aria-label="Jogar como">
        {ROLES.map((r) => (
          <button key={r} type="button" aria-pressed={role === r} onClick={() => setRole(r)}>
            {POSITIONS[r].label}
          </button>
        ))}
      </div>
      <Minimap view={view} kits={kits} />
      {hud && <Feed hud={hud} />}
      {hud && <PilotPanel hud={hud} name={pilot.name} role={role} mode="treino" />}
      <ControlsHelp />
      {state === "erro" && (
        <p className="stage-message" role="alert">
          Não foi possível mostrar o treino em 3D neste navegador.
        </p>
      )}
    </div>
  );
}
